import React from 'react';

import './order-checkout-button.scss';

const OrderCheckoutButton = () => {
  return (
    <div className="order-checkout-btn">
      <span className="btn-text">checkout</span>
    </div>
  );
};

export default OrderCheckoutButton;
